export default "__VITE_ASSET__tKEL3WfB__"